const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Destination Name",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "path_contains",
      label: "Path",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "code_contains",
      label: "Code",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "brand_contains",
      label: "Brand",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "external_code_contains",
      label: "External Code",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      label: "Not In Use",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/admin/destinations/destination-filters.js